<template>
  <div>
    <div class="d-flex align-center">
      <div class="text-4">Total Portfolio Value</div>
      <v-tooltip right max-width="550" color="dark">
        <template v-slot:activator="{ on, attrs }">
          <v-icon x-small class="ml-1 darkgray--text" v-bind="attrs" v-on="on"
            >fas fa-info-circle</v-icon
          >
        </template>
        <div>
          <span v-if="category === 'all'"
            >Your total value locked across DeFi Vaults & PoS networks</span
          >
          <span v-if="category === 'vaults'"
            >Your total deposits locked with DeFi Vaults</span
          >
          <span v-if="category === 'stake'"
            >Your total staked AUM with PoS networks</span
          >
        </div>
      </v-tooltip>
    </div>
    <div class="mt-2 primary--text heading-3 font-weight-medium">
      ${{ totalValue | numberFormat("0,0.00", false) }}
    </div>
    <div class="mt-2 d-flex align-center text-5">
      <span class="gray--text">24h</span>
      <span
        :class="[
          'font-weight-medium ml-1',
          {
            'green--text': change24h.percentage > 0,
            'red--text': change24h.percentage < 0,
            'darkgray--text': change24h.percentage === 0,
          },
        ]"
        ><span></span>
        <span
          ><span v-if="change24h.value < 0">–</span>${{
            change24h.value | abs | numberFormat("0,0")
          }}</span
        >
        <span class="ml-1"
          >(<span v-if="change24h.value < 0">–</span
          ><span v-if="change24h.value > 0">+</span
          ><span
            >{{
              change24h.percentage | abs | numberFormat("0,0.00", false)
            }}%</span
          >)</span
        ></span
      >
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import BN from "bignumber.js";

export default {
  props: ["category"],
  computed: {
    ...mapGetters({
      historicalBalances: "portfolio/historicalBalances",
      totalAvailable: "portfolio/totalAvailable",
    }),
    totalValue() {
      return new BN(
        this.historicalBalances[this.category]?.slice(-1)[0]?.[1] || 0
      )
        .plus(this.totalAvailable)
        .toNumber();
    },
    change24h() {
      if (this.historicalBalances[this.category]?.length && this.totalValue) {
        const prev = new BN(
          this.historicalBalances[this.category].slice(-2)[0][1]
        )
          .plus(this.totalAvailable)
          .toNumber();
        const change = new BN(this.totalValue).minus(prev);
        return {
          percentage: change
            .dividedBy(this.totalValue)
            .multipliedBy(100)
            .toNumber(),
          value: change.toNumber(),
        };
      }
      return {
        percentage: 0,
        value: 0,
      };
    },
  },
};
</script>
